export var name = "@atlaskit/editor-core";
export var version = "204.5.3";